import "./App.css";
import Home from "../src/pages/Home/Home";
import Sectionhome1 from "../src/components/Sections/SectionsHome1";
import Sectionhome2 from "../src/components/Sections/SectionHome2";
import Sectionhome3 from "../src/components/Sections/SectionsHome3";

import Footer from "./components/Footer/Footer";
import Sectionhome4 from "./components/Sections/SectionHome4";
import ContactDetails from "./components/Contatti";
import CookieBanner from "./components/CookieBanner";
import Testimonials from "./components/Sections/Reviews";
import Sectionhome5 from "./components/Sections/SectionHome5";

function App() {
  return (
    <div className="App">
      {" "}
      <header>
        <Home />
        <div className="backgroundHome">
          <Sectionhome1 />
          <Sectionhome4 />
          <Sectionhome3 />
          <Sectionhome2 />
          <Sectionhome5 />
        </div>
        <ContactDetails />
        {/*  <Testimonials/> */}
        {/* <ContactForm/> */}
        <Footer />
      </header>
    </div>
  );
}

export default App;
